// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity_keywords-module__container--pCTrQ{display:inline-block;width:50%;margin-top:8px;cursor:pointer}\n", ""]);
// Exports
exports.locals = {
	"container": "entity_keywords-module__container--pCTrQ"
};
module.exports = exports;
